import { render, staticRenderFns } from "./TaskModuleRulesDisabled.vue?vue&type=template&id=26a59712&scoped=true"
import script from "./TaskModuleRulesDisabled.vue?vue&type=script&lang=js"
export * from "./TaskModuleRulesDisabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a59712",
  null
  
)

export default component.exports